<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  [ngStyle]="overrideStyle"
>
  <path
    d="M7.4729 10.2668C7.4729 9.87036 7.32251 9.5673 7.02173 9.35767C6.7255 9.14803 6.29256 9.04321 5.7229 9.04321V7.40942C6.29712 7.40942 6.73234 7.30916 7.02856 7.10864C7.32479 6.90812 7.4729 6.62101 7.4729 6.24731V6.19263V4.0188C7.4729 3.32153 7.69393 2.83162 8.13599 2.54907C8.57804 2.26196 9.35506 2.11841 10.467 2.11841V3.65649C10.0159 3.67017 9.70369 3.75675 9.53052 3.91626C9.3619 4.07577 9.27759 4.31047 9.27759 4.62036V6.66431C9.25024 7.52108 8.71704 8.02694 7.67798 8.18188V8.26392C8.74438 8.42342 9.27759 8.90649 9.27759 9.71313V9.77466V11.8186C9.27759 12.1285 9.3619 12.3632 9.53052 12.5227C9.69914 12.6822 10.0113 12.7688 10.467 12.7825V14.3274C9.35506 14.3274 8.57804 14.1838 8.13599 13.8967C7.69393 13.6142 7.4729 13.122 7.4729 12.4202V10.2668Z"
    fill="white"
  />
</svg>
